import { SAGA_ACTIONS } from "../../../_config";
import { useApiCall } from "../appApiCallHook";

export function useDashboardApi() {
  const callApi = useApiCall();

  const getAdoptionDashboardCounts = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_ADOPTION_DASHBOARD_COUNTS, data, onSuccess, onError);
  };

  const exportAdoptionCountsToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_ADOPTION_COUNTS_PDF, data, onSuccess, onError);
  };
  const exportAdoptionCountsToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_ADOPTION_COUNTS_XLS, data, onSuccess, onError);
  };
  const exportKpiTotalWRsToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_KPI_TOTAL_WRS_PDF, data, onSuccess, onError);
  };
  const exportKpiTotalWRsToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_KPI_TOTAL_WRS_XLS, data, onSuccess, onError);
  };
  const exportKpiAvgTasksToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_KPI_AVG_TASKS_PDF, data, onSuccess, onError);
  };
  const exportKpiAvgTasksToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_KPI_AVG_TASKS_XLS, data, onSuccess, onError);
  };
  const getCompletedWOsWithoutRootCause = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_COMPLETED_WOS_WITHOUT_ROOT_CAUSE, data, onSuccess, onError);
  };
  const exportCompletedWOsWithoutRootCauseToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_COMPLETED_WOS_WITHOUT_ROOT_CAUSE_PDF, data, onSuccess, onError);
  };
  const exportCompletedWOsWithoutRootCauseToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_COMPLETED_WOS_WITHOUT_ROOT_CAUSE_XLS, data, onSuccess, onError);
  };
  const exportKpiAvgHoursToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_KPI_AVG_HOURS_PDF, data, onSuccess, onError);
  };
  const exportKpiAvgHoursToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_KPI_AVG_HOURS_XLS, data, onSuccess, onError);
  };
  const exportKpiChecklistTasksToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_KPI_CHECKLIST_TASKS_PDF, data, onSuccess, onError);
  };
  const exportKpiChecklistTasksToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_KPI_CHECKLIST_TASKS_XLS, data, onSuccess, onError);
  };
  const exportKpiChecklistCompletionToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_KPI_CHECKLIST_COMPLETION_PDF, data, onSuccess, onError);
  };
  const exportKpiChecklistCompletionToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_KPI_CHECKLIST_COMPLETION_XLS, data, onSuccess, onError);
  };

  const getWorkRequestOrigins = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_WORK_REQUEST_ORIGINS, data, onSuccess, onError);
  };

  const getTaskOriginsGallus = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_TASK_ORIGINS_GALLUS, data, onSuccess, onError);
  };

  const getGrowerTaskOrigins = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_GROWER_TASK_ORIGINS, data, onSuccess, onError);
  };

  const getWRStatusPieChart = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_WR_STATUS_PIE_CHART, data, onSuccess, onError);
  };

  const exportWRStatusPieChartToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_WR_STATUS_PIE_CHART_PDF, data, onSuccess, onError);
  };

  const exportWRStatusPieChartToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_WR_STATUS_PIE_CHART_XLS, data, onSuccess, onError);
  };

  const getUserActivitySummary = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_USER_ACTIVITY_SUMMARY, data, onSuccess, onError);
  };

  const getWRCompletenessByFacility = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_WR_COMPLETENESS_BY_FACILITY, data, onSuccess, onError);
  };

  const exportWRCompletenessByFacilityToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_WR_COMPLETENESS_BY_FACILITY_PDF, data, onSuccess, onError);
  };

  const exportWRCompletenessByFacilityToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_WR_COMPLETENESS_BY_FACILITY_XLS, data, onSuccess, onError);
  };

  const getStockAdjustmentChart = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_STOCK_ADJUSTMENT_CHART, data, onSuccess, onError);
  };

  const getInventoryMovementChart = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_INVENTORY_MOVEMENT_CHART, data, onSuccess, onError);
  };
  const getChecklistByCreator = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_CHECKLIST_BY_CREATOR, data, onSuccess, onError);
  };
  const exportChecklistByCreatorToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_CHECKLIST_BY_CREATOR_PDF, data, onSuccess, onError);
  };
  const exportChecklistByCreatorToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_CHECKLIST_BY_CREATOR_XLS, data, onSuccess, onError);
  };

  const getManagerDashboardWRKPIs = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_MANAGER_DASHBOARD_WR_KPIS, data, onSuccess, onError);
  };

  const getManagerDashboardWR = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_MANAGER_DASHBOARD_WR, data, onSuccess, onError);
  };

  const getManagerDashboardTeam = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_MANAGER_DASHBOARD_TEAM, data, onSuccess, onError);
  };

  const getManagerDashboardPurchasing = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_MANAGER_DASHBOARD_PURCHASING, data, onSuccess, onError);
  };

  const getManagerDashboardAssets = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_MANAGER_DASHBOARD_ASSETS, data, onSuccess, onError);
  };

  const getReliabilityMatrixData = (onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_RELIABILITY_MATRIX_DATA, {}, onSuccess, onError);
  };

  const getClosedTasksReport = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_CLOSED_TASKS_REPORT, data, onSuccess, onError);
  };

  const getAssetsUptimeReport = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_ASSETS_UPTIME_REPORT, data, onSuccess, onError);
  };

  const getAssetsTimeCostReport = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_ASSETS_TIME_COST_REPORT, data, onSuccess, onError);
  };

  const getWarrantiesReport = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_WARRANTIES_REPORT, data, onSuccess, onError);
  };

  const getLowStockReport = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_LOW_STOCK_REPORT, data, onSuccess, onError);
  };

  const exportClosedTasksReportToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_CLOSED_TASKS_REPORT_XLS, data, onSuccess, onError);
  };

  const exportAssetsUptimeReportToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_ASSETS_UPTIME_REPORT_XLS, data, onSuccess, onError);
  };

  const exportAssetsTimeCostReportToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_ASSETS_TIME_COST_REPORT_XLS, data, onSuccess, onError);
  };

  const exportWarrantiesReportToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_WARRANTIES_REPORT_XLS, data, onSuccess, onError);
  };

  const exportLowStockReportToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_LOW_STOCK_REPORT_XLS, data, onSuccess, onError);
  };

  const exportWorkRequestOriginsToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_WORK_REQUEST_ORIGINS_PDF, data, onSuccess, onError);
  };

  const exportWorkRequestOriginsToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_WORK_REQUEST_ORIGINS_XLS, data, onSuccess, onError);
  };

  const exportGrowerTaskOriginsToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_GROWER_TASK_ORIGINS_PDF, data, onSuccess, onError);
  };

  const exportGrowerTaskOriginsToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_GROWER_TASK_ORIGINS_XLS, data, onSuccess, onError);
  };

  const exportUserActivitySummaryToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_USER_ACTIVITY_SUMMARY_PDF, data, onSuccess, onError);
  };

  const exportUserActivitySummaryToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_USER_ACTIVITY_SUMMARY_XLS, data, onSuccess, onError);
  };

  const exportStockAdjustmentToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_STOCK_ADJUSTMENT_PDF, data, onSuccess, onError);
  };

  const exportStockAdjustmentToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_STOCK_ADJUSTMENT_XLS, data, onSuccess, onError);
  };

  const exportInventoryMovementToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_INVENTORY_MOVEMENT_PDF, data, onSuccess, onError);
  };

  const exportInventoryMovementToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_INVENTORY_MOVEMENT_XLS, data, onSuccess, onError);
  };

  const exportManagerWorkRequestsToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_MANAGER_WORK_REQUESTS_PDF, data, onSuccess, onError);
  };

  const exportManagerWorkRequestsToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_MANAGER_WORK_REQUESTS_XLS, data, onSuccess, onError);
  };

  const exportManagerPurchasingToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_MANAGER_PURCHASING_PDF, data, onSuccess, onError);
  };

  const exportManagerPurchasingToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_MANAGER_PURCHASING_XLS, data, onSuccess, onError);
  };

  const exportTaskOriginsGallusToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_TASK_ORIGINS_GALLUS_PDF, data, onSuccess, onError);
  };

  const exportTaskOriginsGallusToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_TASK_ORIGINS_GALLUS_XLS, data, onSuccess, onError);
  };

  const getManagerHoursByFacility = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_MANAGER_HOURS_BY_FACILITY, data, onSuccess, onError);
  };

  const getWRsWithoutTaskByPriority = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_WRS_WITHOUT_TASK_BY_PRIORITY, data, onSuccess, onError);
  };

  const getScheduledTasksByFacility = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_SCHEDULED_TASKS_BY_FACILITY, data, onSuccess, onError);
  };
  

  const exportScheduledTasksDetailToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_SCHEDULED_TASKS_DETAIL_PDF, data, onSuccess, onError);
  };

  const exportScheduledTasksDetailToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_SCHEDULED_TASKS_DETAIL_XLS, data, onSuccess, onError);
  };

  const getTasksAndWRsByFacility = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_TASKS_AND_WRS_BY_FACILITY, data, onSuccess, onError);
  };

  const exportTasksAndWRsByPriorityToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_TASKS_AND_WRS_BY_PRIORITY_PDF, data, onSuccess, onError);
  };

  const exportTasksAndWRsByPriorityToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_TASKS_AND_WRS_BY_PRIORITY_XLS, data, onSuccess, onError);
  };

  const exportManagerKpiWRsWithoutTaskToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_MANAGER_KPI_WRS_WITHOUT_TASK_PDF, data, onSuccess, onError);
  };
  const exportManagerKpiWRsWithoutTaskToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_MANAGER_KPI_WRS_WITHOUT_TASK_XLS, data, onSuccess, onError);
  };
  const exportManagerKpiTasksWithoutAssignmentToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_MANAGER_KPI_TASKS_WITHOUT_ASSIGNMENT_PDF, data, onSuccess, onError);
  };
  const exportManagerKpiTasksWithoutAssignmentToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_MANAGER_KPI_TASKS_WITHOUT_ASSIGNMENT_XLS, data, onSuccess, onError);
  };
  const exportManagerKpiTasksWithoutScheduleToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_MANAGER_KPI_TASKS_WITHOUT_SCHEDULE_PDF, data, onSuccess, onError);
  };
  const exportManagerKpiTasksWithoutScheduleToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_MANAGER_KPI_TASKS_WITHOUT_SCHEDULE_XLS, data, onSuccess, onError);
  };
  const exportManagerKpiTasksNotCompletedToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_MANAGER_KPI_TASKS_NOT_COMPLETED_PDF, data, onSuccess, onError);
  };
  const exportManagerKpiTasksNotCompletedToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_MANAGER_KPI_TASKS_NOT_COMPLETED_XLS, data, onSuccess, onError);
  };
  const exportWRsWithoutTaskByPriorityToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_WRS_WITHOUT_TASK_BY_PRIORITY_PDF, data, onSuccess, onError);
  };
  const exportWRsWithoutTaskByPriorityToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_WRS_WITHOUT_TASK_BY_PRIORITY_XLS, data, onSuccess, onError);
  };

  const getTotalResponseTime = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_TOTAL_RESPONSE_TIME, data, onSuccess, onError);
  };
  const exportTotalResponseTimeToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_TOTAL_RESPONSE_TIME_PDF, data, onSuccess, onError);
  };
  const exportTotalResponseTimeToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_TOTAL_RESPONSE_TIME_XLS, data, onSuccess, onError);
  };

  const exportManagerHoursByFacilityToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_MANAGER_HOURS_BY_FACILITY_PDF, data, onSuccess, onError);
  };

  const exportManagerHoursByFacilityToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_MANAGER_HOURS_BY_FACILITY_XLS, data, onSuccess, onError);
  };

  const getManagerHoursByFacilityLP = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_MANAGER_HOURS_BY_FACILITY_LP, data, onSuccess, onError);
  };

  const exportManagerHoursByFacilityLPToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_MANAGER_HOURS_BY_FACILITY_LP_PDF, data, onSuccess, onError);
  };

  const exportManagerHoursByFacilityLPToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_MANAGER_HOURS_BY_FACILITY_LP_XLS, data, onSuccess, onError);
  };

  const getManagerHoursByFacilityRM = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_MANAGER_HOURS_BY_FACILITY_RM, data, onSuccess, onError);
  };

  const exportManagerHoursByFacilityRMToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_MANAGER_HOURS_BY_FACILITY_RM_PDF, data, onSuccess, onError);
  };

  const exportManagerHoursByFacilityRMToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_MANAGER_HOURS_BY_FACILITY_RM_XLS, data, onSuccess, onError);
  };

  const exportTasksAgingPriorityToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_TASKS_AGING_PRIORITY_PDF, data, onSuccess, onError);
  };

  const exportTasksAgingPriorityToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_TASKS_AGING_PRIORITY_XLS, data, onSuccess, onError);
  };

  const exportWRByPriorityToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_WR_BY_PRIORITY_PDF, data, onSuccess, onError);
  };

  const exportWRByPriorityToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_WR_BY_PRIORITY_XLS, data, onSuccess, onError);
  };

  const exportTaskFunnelToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_TASK_FUNNEL_PDF, data, onSuccess, onError);
  };

  const exportTaskFunnelToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_TASK_FUNNEL_XLS, data, onSuccess, onError);
  };

  const exportHighPriorityWRsToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_HIGH_PRI_WRS_PDF, data, onSuccess, onError);
  };

  const exportHighPriorityWRsToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_HIGH_PRI_WRS_XLS, data, onSuccess, onError);
  };

  const exportTaskCreationTimeToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_TASK_CREATION_TIME_PDF, data, onSuccess, onError);
  };

  const exportTaskCreationTimeToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_TASK_CREATION_TIME_XLS, data, onSuccess, onError);
  };

  const exportTaskCompletionTimeToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_TASK_COMPLETION_TIME_PDF, data, onSuccess, onError);
  };

  const exportTaskCompletionTimeToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_TASK_COMPLETION_TIME_XLS, data, onSuccess, onError);
  };

  const exportCompletedTasksByEmployeeToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_COMPLETED_TASKS_PDF, data, onSuccess, onError);
  };

  const exportCompletedTasksByEmployeeToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_COMPLETED_TASKS_XLS, data, onSuccess, onError);
  };

  const getCompletedTasksByFarm = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_COMPLETED_TASKS_BY_FARM, data, onSuccess, onError);
  };

  const exportCompletedTasksByFarmToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_COMPLETED_TASKS_BY_FARM_PDF, data, onSuccess, onError);
  };

  const exportCompletedTasksByFarmToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_COMPLETED_TASKS_BY_FARM_XLS, data, onSuccess, onError);
  };

  const getCompletedTasksByRM = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_COMPLETED_TASKS_BY_RM, data, onSuccess, onError);
  };
  const exportCompletedTasksByRMToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_COMPLETED_TASKS_BY_RM_PDF, data, onSuccess, onError);
  };
  const exportCompletedTasksByRMToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_COMPLETED_TASKS_BY_RM_XLS, data, onSuccess, onError);
  };

  const getCompletedTasksByLP = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_COMPLETED_TASKS_BY_LP, data, onSuccess, onError);
  };
  const exportCompletedTasksByLPToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_COMPLETED_TASKS_BY_LP_PDF, data, onSuccess, onError);
  };
  const exportCompletedTasksByLPToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_COMPLETED_TASKS_BY_LP_XLS, data, onSuccess, onError);
  };

  const getCompletedTasksByGrower = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_COMPLETED_TASKS_BY_GROWER, data, onSuccess, onError);
  };
  const exportCompletedTasksByGrowerToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_COMPLETED_TASKS_BY_GROWER_PDF, data, onSuccess, onError);
  };
  const exportCompletedTasksByGrowerToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_COMPLETED_TASKS_BY_GROWER_XLS, data, onSuccess, onError);
  };

  const getLoggedHoursByRM = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_LOGGED_HOURS_BY_RM, data, onSuccess, onError);
  };
  const exportLoggedHoursByRMToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_LOGGED_HOURS_BY_RM_PDF, data, onSuccess, onError);
  };
  const exportLoggedHoursByRMToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_LOGGED_HOURS_BY_RM_XLS, data, onSuccess, onError);
  };

  const getLoggedHoursByLP = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_LOGGED_HOURS_BY_LP, data, onSuccess, onError);
  };
  const exportLoggedHoursByLPToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_LOGGED_HOURS_BY_LP_PDF, data, onSuccess, onError);
  };
  const exportLoggedHoursByLPToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_LOGGED_HOURS_BY_LP_XLS, data, onSuccess, onError);
  };

  const getLoggedHoursByGrower = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_LOGGED_HOURS_BY_GROWER, data, onSuccess, onError);
  };
  const exportLoggedHoursByGrowerToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_LOGGED_HOURS_BY_GROWER_PDF, data, onSuccess, onError);
  };
  const exportLoggedHoursByGrowerToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_LOGGED_HOURS_BY_GROWER_XLS, data, onSuccess, onError);
  };

  const exportLoggedHoursByEmployeeToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_LOGGED_HOURS_PDF, data, onSuccess, onError);
  };

  const exportLoggedHoursByEmployeeToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_LOGGED_HOURS_XLS, data, onSuccess, onError);
  };

  const exportPMReactiveToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_PM_REACTIVE_PDF, data, onSuccess, onError);
  };

  const exportPMReactiveToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_PM_REACTIVE_XLS, data, onSuccess, onError);
  };

  const getPurchasingMethodByWO = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_PURCHASING_METHOD_BY_WO, data, onSuccess, onError);
  };
  const exportPurchasingMethodCountToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_PURCHASING_METHOD_COUNT_PDF, data, onSuccess, onError);
  };
  const exportPurchasingMethodCountToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_PURCHASING_METHOD_COUNT_XLS, data, onSuccess, onError);
  };
  const exportPurchasingMethodValueToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_PURCHASING_METHOD_VALUE_PDF, data, onSuccess, onError);
  };
  const exportPurchasingMethodValueToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_PURCHASING_METHOD_VALUE_XLS, data, onSuccess, onError);
  };
  const exportPurchasingMethodToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_PURCHASING_METHOD_PDF, data, onSuccess, onError);
  };

  const exportPurchasingMethodToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_PURCHASING_METHOD_XLS, data, onSuccess, onError);
  };

  const exportPurchasingSpendToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_PURCHASING_SPEND_PDF, data, onSuccess, onError);
  };

  const exportPurchasingSpendToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_PURCHASING_SPEND_XLS, data, onSuccess, onError);
  };

  const exportGoodsOnOrderToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_GOODS_ON_ORDER_PDF, data, onSuccess, onError);
  };

  const exportGoodsOnOrderToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_GOODS_ON_ORDER_XLS, data, onSuccess, onError);
  };

  const exportPurchaseReceiptsToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_PURCHASE_RECEIPTS_PDF, data, onSuccess, onError);
  };

  const exportPurchaseReceiptsToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_PURCHASE_RECEIPTS_XLS, data, onSuccess, onError);
  };

  const exportLowInventoryToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_LOW_INVENTORY_PDF, data, onSuccess, onError);
  };

  const exportLowInventoryToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_LOW_INVENTORY_XLS, data, onSuccess, onError);
  };

  const exportDownAssetsToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_DOWN_ASSETS_PDF, data, onSuccess, onError);
  };

  const exportDownAssetsToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_DOWN_ASSETS_XLS, data, onSuccess, onError);
  };

  const exportAssetDowntimeToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_ASSET_DOWNTIME_PDF, data, onSuccess, onError);
  };

  const exportAssetDowntimeToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_ASSET_DOWNTIME_XLS, data, onSuccess, onError);
  };

  const exportMttrMtbfToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_MTTR_MTBF_PDF, data, onSuccess, onError);
  };

  const exportMttrMtbfToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_MTTR_MTBF_XLS, data, onSuccess, onError);
  };

  const exportReliabilityMatrixToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_RELIABILITY_MATRIX_PDF, data, onSuccess, onError);
  };

  const exportReliabilityMatrixToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_RELIABILITY_MATRIX_XLS, data, onSuccess, onError);
  };

  const exportExpiringWarrantiesToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_EXPIRING_WARRANTIES_PDF, data, onSuccess, onError);
  };

  const exportExpiringWarrantiesToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_EXPIRING_WARRANTIES_XLS, data, onSuccess, onError);
  };

  const getMyDashboardWRByFarm = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_MY_DASHBOARD_WR_BY_FARM, data, onSuccess, onError);
  };

  const getMyDashboardWROverTime = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_MY_DASHBOARD_WR_OVER_TIME, data, onSuccess, onError);
  };

  const getMyDashboardTasksByFarm = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_MY_DASHBOARD_TASKS_BY_FARM, data, onSuccess, onError);
  };

  const getMyDashboardTasksOverTime = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_MY_DASHBOARD_TASKS_OVER_TIME, data, onSuccess, onError);
  };

  const getMyDashboardResponsivenessByFarm = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_MY_DASHBOARD_RESPONSIVENESS_BY_FARM, data, onSuccess, onError);
  };

  const getMyDashboardResponsivenessIndividual = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_MY_DASHBOARD_RESPONSIVENESS_INDIVIDUAL, data, onSuccess, onError);
  };

  const getMyDashboardWalkthroughsByFarm = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_MY_DASHBOARD_WALKTHROUGHS_BY_FARM, data, onSuccess, onError);
  };

  const getMyDashboardWalkthroughsOverTime = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_MY_DASHBOARD_WALKTHROUGHS_OVER_TIME, data, onSuccess, onError);
  };
   const getMyDashboardReactiveHoursByFarm = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_MY_DASHBOARD_REACTIVE_HOURS_BY_FARM, data, onSuccess, onError);
  };

  const getMyDashboardReactiveHoursOverTime = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_MY_DASHBOARD_REACTIVE_HOURS_OVER_TIME, data, onSuccess, onError);
  };

  const getMyDashboardReactiveByFarm = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_MY_DASHBOARD_REACTIVE_BY_FARM, data, onSuccess, onError);
  };

  const getMyDashboardReactiveOverTime = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_MY_DASHBOARD_REACTIVE_OVER_TIME, data, onSuccess, onError);
  };

  const getMyDashboardPMByFarm = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_MY_DASHBOARD_PM_BY_FARM, data, onSuccess, onError);
  };

  const getMyDashboardPMOverTime = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_MY_DASHBOARD_PM_OVER_TIME, data, onSuccess, onError);
  };
  
const getMyDashboardWREmptyFields = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_MY_DASHBOARD_WR_EMPTY_FIELDS, data, onSuccess, onError);
  };

  const getMyDashboardRootCauseFilled = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_MY_DASHBOARD_ROOT_CAUSE_FILLED, data, onSuccess, onError);
  };

  const getMyDashboardRootCauseOverTime = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_MY_DASHBOARD_ROOT_CAUSE_OVER_TIME, data, onSuccess, onError);
  };

  const getMyDashboardWalkthroughMissingData = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_MY_DASHBOARD_WALKTHROUGH_MISSING_DATA, data, onSuccess, onError);
  };

  const getMyDashboardWalkthroughMissingDataOverTime = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.GET_MY_DASHBOARD_WALKTHROUGH_MISSING_DATA_OVER_TIME, data, onSuccess, onError);
  };

  const exportMyDashboardToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_MY_DASHBOARD_TO_XLS, data, onSuccess, onError);
  };

  const exportMyDashboardToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_MY_DASHBOARD_TO_PDF, data, onSuccess, onError);
  };

  const exportMyDashboardWRByFarmToPDF = (data: any, onSuccess: Function, onError: Function) => { callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_MY_DASHBOARD_WR_BY_FARM_PDF, data, onSuccess, onError); };
  const exportMyDashboardWRByFarmToXLS = (data: any, onSuccess: Function, onError: Function) => { callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_MY_DASHBOARD_WR_BY_FARM_XLS, data, onSuccess, onError); };
  const exportMyDashboardWROverTimeToPDF = (data: any, onSuccess: Function, onError: Function) => { callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_MY_DASHBOARD_WR_OVER_TIME_PDF, data, onSuccess, onError); };
  const exportMyDashboardWROverTimeToXLS = (data: any, onSuccess: Function, onError: Function) => { callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_MY_DASHBOARD_WR_OVER_TIME_XLS, data, onSuccess, onError); };
  const exportMyDashboardTasksByFarmToPDF = (data: any, onSuccess: Function, onError: Function) => { callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_MY_DASHBOARD_TASKS_BY_FARM_PDF, data, onSuccess, onError); };
  const exportMyDashboardTasksByFarmToXLS = (data: any, onSuccess: Function, onError: Function) => { callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_MY_DASHBOARD_TASKS_BY_FARM_XLS, data, onSuccess, onError); };
  const exportMyDashboardTasksOverTimeToPDF = (data: any, onSuccess: Function, onError: Function) => { callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_MY_DASHBOARD_TASKS_OVER_TIME_PDF, data, onSuccess, onError); };
  const exportMyDashboardTasksOverTimeToXLS = (data: any, onSuccess: Function, onError: Function) => { callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_MY_DASHBOARD_TASKS_OVER_TIME_XLS, data, onSuccess, onError); };
  const exportMyDashboardRespByFarmToPDF = (data: any, onSuccess: Function, onError: Function) => { callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_MY_DASHBOARD_RESP_BY_FARM_PDF, data, onSuccess, onError); };
  const exportMyDashboardRespByFarmToXLS = (data: any, onSuccess: Function, onError: Function) => { callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_MY_DASHBOARD_RESP_BY_FARM_XLS, data, onSuccess, onError); };
  const exportMyDashboardRespIndToPDF = (data: any, onSuccess: Function, onError: Function) => { callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_MY_DASHBOARD_RESP_IND_PDF, data, onSuccess, onError); };
  const exportMyDashboardRespIndToXLS = (data: any, onSuccess: Function, onError: Function) => { callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_MY_DASHBOARD_RESP_IND_XLS, data, onSuccess, onError); };
  const exportMyDashboardWalkByFarmToPDF = (data: any, onSuccess: Function, onError: Function) => { callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_MY_DASHBOARD_WALK_BY_FARM_PDF, data, onSuccess, onError); };
  const exportMyDashboardWalkByFarmToXLS = (data: any, onSuccess: Function, onError: Function) => { callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_MY_DASHBOARD_WALK_BY_FARM_XLS, data, onSuccess, onError); };
  const exportMyDashboardWalkOverTimeToPDF = (data: any, onSuccess: Function, onError: Function) => { callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_MY_DASHBOARD_WALK_OVER_TIME_PDF, data, onSuccess, onError); };
  const exportMyDashboardWalkOverTimeToXLS = (data: any, onSuccess: Function, onError: Function) => { callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_MY_DASHBOARD_WALK_OVER_TIME_XLS, data, onSuccess, onError); };
  const exportMyDashboardPMByFarmToPDF = (data: any, onSuccess: Function, onError: Function) => { callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_MY_DASHBOARD_PM_BY_FARM_PDF, data, onSuccess, onError); };
  const exportMyDashboardPMByFarmToXLS = (data: any, onSuccess: Function, onError: Function) => { callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_MY_DASHBOARD_PM_BY_FARM_XLS, data, onSuccess, onError); };
  const exportMyDashboardPMOverTimeToPDF = (data: any, onSuccess: Function, onError: Function) => { callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_MY_DASHBOARD_PM_OVER_TIME_PDF, data, onSuccess, onError); };
  const exportMyDashboardPMOverTimeToXLS = (data: any, onSuccess: Function, onError: Function) => { callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_MY_DASHBOARD_PM_OVER_TIME_XLS, data, onSuccess, onError); };
  const exportMyDashboardReactiveByFarmToPDF = (data: any, onSuccess: Function, onError: Function) => { callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_MY_DASHBOARD_REACTIVE_BY_FARM_PDF, data, onSuccess, onError); };
  const exportMyDashboardReactiveByFarmToXLS = (data: any, onSuccess: Function, onError: Function) => { callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_MY_DASHBOARD_REACTIVE_BY_FARM_XLS, data, onSuccess, onError); };
  const exportMyDashboardReactiveOverTimeToPDF = (data: any, onSuccess: Function, onError: Function) => { callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_MY_DASHBOARD_REACTIVE_OVER_TIME_PDF, data, onSuccess, onError); };
  const exportMyDashboardReactiveOverTimeToXLS = (data: any, onSuccess: Function, onError: Function) => { callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_MY_DASHBOARD_REACTIVE_OVER_TIME_XLS, data, onSuccess, onError); };
  const exportMyDashboardHoursByFarmToPDF = (data: any, onSuccess: Function, onError: Function) => { callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_MY_DASHBOARD_HOURS_BY_FARM_PDF, data, onSuccess, onError); };
  const exportMyDashboardHoursByFarmToXLS = (data: any, onSuccess: Function, onError: Function) => { callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_MY_DASHBOARD_HOURS_BY_FARM_XLS, data, onSuccess, onError); };
  const exportMyDashboardHoursOverTimeToPDF = (data: any, onSuccess: Function, onError: Function) => { callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_MY_DASHBOARD_HOURS_OVER_TIME_PDF, data, onSuccess, onError); };
  const exportMyDashboardHoursOverTimeToXLS = (data: any, onSuccess: Function, onError: Function) => { callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_MY_DASHBOARD_HOURS_OVER_TIME_XLS, data, onSuccess, onError); };
  const exportMyDashboardRootCauseToPDF = (data: any, onSuccess: Function, onError: Function) => { callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_MY_DASHBOARD_ROOT_CAUSE_PDF, data, onSuccess, onError); };
  const exportMyDashboardRootCauseToXLS = (data: any, onSuccess: Function, onError: Function) => { callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_MY_DASHBOARD_ROOT_CAUSE_XLS, data, onSuccess, onError); };
  const exportMyDashboardWREmptyFieldsToPDF = (data: any, onSuccess: Function, onError: Function) => { callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_MY_DASHBOARD_WR_EMPTY_FIELDS_PDF, data, onSuccess, onError); };
  const exportMyDashboardWREmptyFieldsToXLS = (data: any, onSuccess: Function, onError: Function) => { callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_MY_DASHBOARD_WR_EMPTY_FIELDS_XLS, data, onSuccess, onError); };
  const exportMyDashboardWTMissingToPDF = (data: any, onSuccess: Function, onError: Function) => { callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_MY_DASHBOARD_WT_MISSING_PDF, data, onSuccess, onError); };
  const exportMyDashboardWTMissingToXLS = (data: any, onSuccess: Function, onError: Function) => { callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_MY_DASHBOARD_WT_MISSING_XLS, data, onSuccess, onError); };
  const exportMyDashboardWTMissingOverTimeToPDF = (data: any, onSuccess: Function, onError: Function) => { callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_MY_DASHBOARD_WT_MISSING_OT_PDF, data, onSuccess, onError); };
  const exportMyDashboardWTMissingOverTimeToXLS = (data: any, onSuccess: Function, onError: Function) => { callApi(SAGA_ACTIONS.DASHBOARD.EXPORT_MY_DASHBOARD_WT_MISSING_OT_XLS, data, onSuccess, onError); };	
	

  return {
    getAdoptionDashboardCounts,
    exportAdoptionCountsToPDF,
    exportAdoptionCountsToXLS,
    exportKpiTotalWRsToPDF,
    exportKpiTotalWRsToXLS,
    exportKpiAvgTasksToPDF,
    exportKpiAvgTasksToXLS,
    getCompletedWOsWithoutRootCause,
    exportCompletedWOsWithoutRootCauseToPDF,
    exportCompletedWOsWithoutRootCauseToXLS,
    exportKpiAvgHoursToPDF,
    exportKpiAvgHoursToXLS,
    exportKpiChecklistTasksToPDF,
    exportKpiChecklistTasksToXLS,
    exportKpiChecklistCompletionToPDF,
    exportKpiChecklistCompletionToXLS,
    getWorkRequestOrigins,
    getTaskOriginsGallus,
    getGrowerTaskOrigins,
    getWRStatusPieChart,
    exportWRStatusPieChartToPDF,
    exportWRStatusPieChartToXLS,
    getUserActivitySummary,
    getWRCompletenessByFacility,
    exportWRCompletenessByFacilityToPDF,
    exportWRCompletenessByFacilityToXLS,
    getStockAdjustmentChart,
    getInventoryMovementChart,
    getChecklistByCreator,
    exportChecklistByCreatorToPDF,
    exportChecklistByCreatorToXLS,
    getManagerDashboardWRKPIs,
    getManagerDashboardWR,
    getManagerDashboardTeam,
    getManagerDashboardPurchasing,
    getManagerDashboardAssets,
    getReliabilityMatrixData,
    getClosedTasksReport,
    getAssetsUptimeReport,
    getAssetsTimeCostReport,
    getWarrantiesReport,
    getLowStockReport,
    exportWorkRequestOriginsToPDF,
    exportWorkRequestOriginsToXLS,
    exportGrowerTaskOriginsToPDF,
    exportGrowerTaskOriginsToXLS,
    exportUserActivitySummaryToPDF,
    exportUserActivitySummaryToXLS,
    exportStockAdjustmentToPDF,
    exportStockAdjustmentToXLS,
    exportInventoryMovementToPDF,
    exportInventoryMovementToXLS,
    exportManagerWorkRequestsToPDF,
    exportManagerWorkRequestsToXLS,
    exportManagerPurchasingToPDF,
    exportManagerPurchasingToXLS,
    exportTaskOriginsGallusToPDF,
    exportTaskOriginsGallusToXLS,
    getManagerHoursByFacility,
    exportManagerHoursByFacilityToPDF,
    exportManagerHoursByFacilityToXLS,
    getManagerHoursByFacilityLP,
    exportManagerHoursByFacilityLPToPDF,
    exportManagerHoursByFacilityLPToXLS,
    getManagerHoursByFacilityRM,
    exportManagerHoursByFacilityRMToPDF,
    exportManagerHoursByFacilityRMToXLS,
    exportTasksAgingPriorityToPDF,
    exportTasksAgingPriorityToXLS,
    exportWRByPriorityToPDF,
    exportWRByPriorityToXLS,
    exportTaskFunnelToPDF,
    exportTaskFunnelToXLS,
    exportHighPriorityWRsToPDF,
    exportHighPriorityWRsToXLS,
    exportTaskCreationTimeToPDF,
    exportTaskCreationTimeToXLS,
    exportTaskCompletionTimeToPDF,
    exportTaskCompletionTimeToXLS,
    exportCompletedTasksByEmployeeToPDF,
    exportCompletedTasksByEmployeeToXLS,
    getCompletedTasksByFarm,
    exportCompletedTasksByFarmToPDF,
    exportCompletedTasksByFarmToXLS,
    getCompletedTasksByRM,
    exportCompletedTasksByRMToPDF,
    exportCompletedTasksByRMToXLS,
    getCompletedTasksByLP,
    exportCompletedTasksByLPToPDF,
    exportCompletedTasksByLPToXLS,
    getCompletedTasksByGrower,
    exportCompletedTasksByGrowerToPDF,
    exportCompletedTasksByGrowerToXLS,
    getLoggedHoursByRM,
    exportLoggedHoursByRMToPDF,
    exportLoggedHoursByRMToXLS,
    getLoggedHoursByLP,
    exportLoggedHoursByLPToPDF,
    exportLoggedHoursByLPToXLS,
    getLoggedHoursByGrower,
    exportLoggedHoursByGrowerToPDF,
    exportLoggedHoursByGrowerToXLS,
    exportLoggedHoursByEmployeeToPDF,
    exportLoggedHoursByEmployeeToXLS,
    exportPMReactiveToPDF,
    exportPMReactiveToXLS,
    getPurchasingMethodByWO,
    exportPurchasingMethodCountToPDF,
    exportPurchasingMethodCountToXLS,
    exportPurchasingMethodValueToPDF,
    exportPurchasingMethodValueToXLS,
    exportPurchasingMethodToPDF,
    exportPurchasingMethodToXLS,
    exportPurchasingSpendToPDF,
    exportPurchasingSpendToXLS,
    exportGoodsOnOrderToPDF,
    exportGoodsOnOrderToXLS,
    exportPurchaseReceiptsToPDF,
    exportPurchaseReceiptsToXLS,
    exportLowInventoryToPDF,
    exportLowInventoryToXLS,
    exportDownAssetsToPDF,
    exportDownAssetsToXLS,
    exportAssetDowntimeToPDF,
    exportAssetDowntimeToXLS,
    exportMttrMtbfToPDF,
    exportMttrMtbfToXLS,
    exportReliabilityMatrixToPDF,
    exportReliabilityMatrixToXLS,
    exportExpiringWarrantiesToPDF,
    exportExpiringWarrantiesToXLS,
    exportClosedTasksReportToXLS,
    exportAssetsUptimeReportToXLS,
    exportAssetsTimeCostReportToXLS,
    exportWarrantiesReportToXLS,
    exportLowStockReportToXLS,
    getWRsWithoutTaskByPriority,
    getScheduledTasksByFacility,
    exportScheduledTasksDetailToPDF,
    exportScheduledTasksDetailToXLS,
    getTasksAndWRsByFacility,
    exportTasksAndWRsByPriorityToPDF,
    exportTasksAndWRsByPriorityToXLS,
    exportManagerKpiWRsWithoutTaskToPDF,
    exportManagerKpiWRsWithoutTaskToXLS,
    exportManagerKpiTasksWithoutAssignmentToPDF,
    exportManagerKpiTasksWithoutAssignmentToXLS,
    exportManagerKpiTasksWithoutScheduleToPDF,
    exportManagerKpiTasksWithoutScheduleToXLS,
    exportManagerKpiTasksNotCompletedToPDF,
    exportManagerKpiTasksNotCompletedToXLS,
    exportWRsWithoutTaskByPriorityToPDF,
    exportWRsWithoutTaskByPriorityToXLS,
    getTotalResponseTime,
    exportTotalResponseTimeToPDF,
    exportTotalResponseTimeToXLS,
    getMyDashboardWRByFarm,
    getMyDashboardWROverTime,
    getMyDashboardTasksByFarm,
    getMyDashboardTasksOverTime,
    getMyDashboardResponsivenessByFarm,
    getMyDashboardResponsivenessIndividual,
    getMyDashboardWalkthroughsByFarm,
    getMyDashboardWalkthroughsOverTime,
    getMyDashboardPMByFarm,
    getMyDashboardPMOverTime,
    getMyDashboardReactiveByFarm,
    getMyDashboardReactiveOverTime,
    getMyDashboardReactiveHoursByFarm,
    getMyDashboardReactiveHoursOverTime,
    getMyDashboardWREmptyFields,
    getMyDashboardRootCauseFilled,
    getMyDashboardRootCauseOverTime,
    getMyDashboardWalkthroughMissingData,
    getMyDashboardWalkthroughMissingDataOverTime,
    exportMyDashboardToXLS,
    exportMyDashboardToPDF,
    exportMyDashboardWRByFarmToPDF, exportMyDashboardWRByFarmToXLS,
    exportMyDashboardWROverTimeToPDF, exportMyDashboardWROverTimeToXLS,
    exportMyDashboardTasksByFarmToPDF, exportMyDashboardTasksByFarmToXLS,
    exportMyDashboardTasksOverTimeToPDF, exportMyDashboardTasksOverTimeToXLS,
    exportMyDashboardRespByFarmToPDF, exportMyDashboardRespByFarmToXLS,
    exportMyDashboardRespIndToPDF, exportMyDashboardRespIndToXLS,
    exportMyDashboardWalkByFarmToPDF, exportMyDashboardWalkByFarmToXLS,
    exportMyDashboardWalkOverTimeToPDF, exportMyDashboardWalkOverTimeToXLS,
    exportMyDashboardPMByFarmToPDF, exportMyDashboardPMByFarmToXLS,
    exportMyDashboardPMOverTimeToPDF, exportMyDashboardPMOverTimeToXLS,
    exportMyDashboardReactiveByFarmToPDF, exportMyDashboardReactiveByFarmToXLS,
    exportMyDashboardReactiveOverTimeToPDF, exportMyDashboardReactiveOverTimeToXLS,
    exportMyDashboardHoursByFarmToPDF, exportMyDashboardHoursByFarmToXLS,
    exportMyDashboardHoursOverTimeToPDF, exportMyDashboardHoursOverTimeToXLS,
    exportMyDashboardRootCauseToPDF, exportMyDashboardRootCauseToXLS,
    exportMyDashboardWREmptyFieldsToPDF, exportMyDashboardWREmptyFieldsToXLS,
    exportMyDashboardWTMissingToPDF, exportMyDashboardWTMissingToXLS,
    exportMyDashboardWTMissingOverTimeToPDF, exportMyDashboardWTMissingOverTimeToXLS,
  };
}
